export default __webpack_public_path__ + "static/media/classHub.cbfe150d.svg";